import SectionHeader from './SectionHeader';

export default SectionHeader;
export type { SectionHeaderProps } from './SectionHeader';
